import Loadable from '../../components/loadable';

const WaiversList = Loadable({
  loader: () => import('../../pages/waivers/waivers_list/waivers_list'),
  type: 'block',
});

angular.module('gym').value('WaiversList', WaiversList);

const WaiversListFiltersModal = Loadable({
  loader: () => import('../../pages/waivers/waivers_list/waivers_list_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('WaiversListFiltersModal', WaiversListFiltersModal);
